import { Button, List, ListItem, Stack } from '@mui/material';
import { useChat } from '@mui/x-chat/headless';
import { ArrowRightIcon } from '@phosphor-icons/react';

import { Text } from 'common';

import { AgenticChatConversationRecentChats } from './RecentChats';

export function AgenticChatEmptyState() {
  const chat = useChat();
  return (
    <Stack
      sx={{
        // MUI Chat's inner wrapper shrinks to content; fill the overlay so recent chats stay at the bottom.
        position: 'absolute',
        inset: 0,
        overflowY: 'auto',
        paddingX: 3,
        paddingTop: 5,
        paddingBottom: 3,
      }}
    >
      <Stack gap={1.5} sx={{ width: '100%', maxWidth: 'lg', marginX: 'auto', flex: 1 }}>
        <Stack gap={3} sx={{ paddingLeft: 2 }}>
          <Text variant="caption" color="text.secondary">
            It&apos;s{' '}
            {new Intl.DateTimeFormat(undefined, {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
            }).format(new Date())}
            .
          </Text>
          <Text variant="heading2">What can we do today?</Text>
        </Stack>
        <List disablePadding aria-label="Suggested prompts">
          {[
            {
              label: 'Check a flow before launch',
              prompt:
                'Help me check a flow for deployment readiness. First ask me which flow I want to check, then help identify its saved definition and review it for deployment readiness.',
            },
            {
              label: 'Document a flow',
              prompt:
                'Help me document a flow. First ask me which flow I want to document, then explain its purpose, steps, branches, and subflows.',
            },
            {
              label: 'Investigate failed runs',
              prompt:
                'Help me analyze failed runs for a flow. First ask me which flow and time period to investigate, then group failures by likely cause, explain the evidence, and suggest improvements.',
            },
            {
              label: 'Clarify build requirements',
              prompt:
                'Help me scope a workflow. First ask me to describe the workflow, then identify missing details and ask clarifying questions before we build.',
            },
          ].map((suggestion) => (
            <ListItem key={suggestion.label} disablePadding>
              <Button
                variant="text"
                color="inherit"
                fullWidth
                startIcon={<ArrowRightIcon size={16} aria-hidden />}
                disabled={chat.isStreaming}
                onClick={() => {
                  void chat.sendMessage({ parts: [{ type: 'text', text: suggestion.prompt }] });
                }}
                sx={{
                  justifyContent: 'flex-start',
                  paddingX: 2,
                  paddingY: 1,
                  borderRadius: 1,
                  '& .MuiButton-startIcon': {
                    color: 'text.secondary',
                    '& > :nth-of-type(1)': {
                      fontSize: 16,
                      width: 16,
                      height: 16,
                    },
                  },
                  '&:hover': {
                    backgroundColor: (theme) => theme.colors.background.disabled,
                  },
                }}
              >
                <Text component="span" variant="body2" color="inherit">
                  {suggestion.label}
                </Text>
              </Button>
            </ListItem>
          ))}
        </List>
        <Stack flex={1} justifyContent="flex-end">
          <AgenticChatConversationRecentChats />
        </Stack>
      </Stack>
    </Stack>
  );
}
